<div style="width: auto; max-width: 70%;" class="mt-3">
    @if (isDanger) {
    <div class="alert alert-danger" role="alert" aria-live="assertive">
        {{ message | translate }}
        <button *ngIf="!noClose" (click)="closeAlert()" type="button" class="btn-close btn-close-black float-end"
            [attr.aria-label]="'buttons.closeAlert' | translate">
        </button>
    </div>
    }
    @if (isOk) {
    <div class="alert alert-primary" role="alert" aria-live="polite">
        {{ message | translate }}
        <button *ngIf="!noClose" (click)="closeAlert()" type="button" class="btn-close btn-close-black float-end"
            [attr.aria-label]="'buttons.closeAlert' | translate">
        </button>
    </div>
    }
</div>